export {
  get as getCookie,
  set as setCookie,
  remove as removeCookie
} from 'js-cookie'
